







import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

export enum ScreenSizeConstraints {
  hideFor='hideFor',
  showOnly='showOnly'
}

@Component
export default class ScreenSizeVisibility extends Vue {
  @Prop({default: ScreenSizeConstraints.showOnly})
  private constraint: ScreenSizeConstraints;

  @Prop()
  private size: string;

  @Prop()
  private inline: boolean;

  @Prop()
  private andDown: boolean;

  private get breakpoints (): any {
    return this.$vuetify.breakpoint;
  }

  private get breakpoint () {
    return this.andDown
      ? this.breakpoints[`${this.size}AndDown`]
      : this.breakpoints.name;
  }

  private get gonaShow(): boolean {
    const isShowOnly = ScreenSizeConstraints.showOnly === this.constraint;
    const isAtSpecSize = this.andDown ? this.breakpoint : this.breakpoint === this.size;

    return isShowOnly ? isAtSpecSize : !isAtSpecSize;
  }
}
